import * as getters from "../../baseQuestion/searchableStaticDDL/store/getters";
import * as mutations from "../../baseQuestion/searchableStaticDDL/store/mutations";
import * as actions from "../../baseQuestion/searchableStaticDDL/store/actions";
import { state as base_state } from "../../baseQuestion/searchableStaticDDL/store/state";

function state() {
	return Object.assign(
		{
			multi_field_parent: "q_publications",
			options: [
				{
					value: "PUB004",
					text: "Journalism"
				},
				{
					value: "PUB002",
					text: "Newspaper"
				},
				{
					value: "PUB001",
					text: "Yearbook"
				}
			]
		},
		base_state()
	);
}

export default {
	namespaced: true,
	state,
	getters,
	mutations,
	actions
};
